import {Component, ElementRef, EventEmitter, Input, Output, QueryList, TemplateRef, ViewChildren} from "@angular/core";

@Component({
    selector: "app-table",
    styleUrls: ["./style.css"],
    template: `
        <div class="col-12 table-wrapper">
            <table class="table table-bordered table-responsive-md table-hover table-sm"  [ngClass]="{'table-striped': tableStriped}">
                <thead>
                <tr class="table-active" [ngClass]="{'text-center': centerHeaderAndRows}">
                    <th *ngIf="checkbox"></th>
                    <th *ngFor="let coluna of colunas" [ngClass]="{'text-center': coluna?.button}" [ngStyle]="coluna?.stylesTitle">{{coluna.title}}</th>
                    <th *ngIf="downloadAttachment" class="text-center">Download</th>
                    <th *ngIf="detailsRow" class="text-center">Detalhes</th>
                    <th *ngIf="deleteRow" class="text-center">Excluir</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let linha of dados | slice: (page-1) * _pageSize : page * _pageSize; let indexDado = index"
                    [ngClass]="getClassMap(linha)"
                    [style.cursor]="dblRowClick||selectable?'pointer':'initial'"
                    [style.background-color]="linha._selected? '#b0b6b6' : ''"
                    (dblclick)="dblRowClick && dblRowClick(linha)"
                    (click)="rowClick(linha)">
                    <ng-template #defaultRow>
                        <td *ngIf="checkbox">
                            <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="linha.checked" >
                        </td>
                        <td (click)="startEdit(indexDado, indexColuna)" *ngFor="let coluna of colunas; let indexColuna = index"  [ngStyle]="coluna?.styles">
                            <ng-container *ngIf="coluna.options?.currency && !isEditing(indexDado, indexColuna)">{{linha[coluna.columnName] | currency}}</ng-container>
                            <ng-container *ngIf="coluna.options?.date">{{linha[coluna.columnName] | date:'dd/MM/yyyy' }}</ng-container>
                            <ng-container *ngIf="coluna.options?.datetime">{{linha[coluna.columnName] | date:'dd/MM/yyyy - HH:mm:ss' }}</ng-container>
                            <ng-container *ngIf="coluna?.button" class="text-center">
                                <button (click)="coluna.button.actionButton(linha)" type="button" class="btn col-8 "
                                        [ngClass]="{'btn-success': linha['liberado'] === 'N' || linha['liberado'] === null,
                                        'btn-danger': linha['liberado'] === 'S'}"
                                >
                                    {{linha['liberado'] === 'N' || linha['liberado'] === null  ? "Liberar" : "Bloquear"}}
                                </button>
                            </ng-container>
                            <ng-container *ngIf="!coluna.options && !isEditing(indexDado, indexColuna)">{{linha[coluna.columnName]}}</ng-container>
                            <ng-container *ngIf="isEditing(indexDado, indexColuna)">
                                <div class="input-group" *ngIf="!coluna.selectColumn">
                                    <input
                                        #inputField
                                        type="text" (keydown.tab)="focusNextInput($event, indexDado, indexColuna)"
                                        (keydown.enter)="stopEdit(indexDado, indexColuna); $event.stopPropagation()"
                                        class="form-control"
                                        [(ngModel)]="linha[coluna.columnName]"
                                        [ngModelOptions]="{ standalone: true }"
                                    />
                                    <div class="input-group-append">
                                        <button
                                            (click)="stopEdit(indexDado, indexColuna); $event.stopPropagation()"
                                            class="btn btn-outline-secondary"
                                            type="button"
                                            id="button-target"
                                        >
                                            <i class="bi bi-check2"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="input-group" *ngIf="coluna.selectColumn">
                                    <select
                                        class="form-control"
                                        (keydown.tab)="focusNextInput($event, indexDado, indexColuna)"
                                        (keydown.enter)="stopEdit(indexDado, indexColuna); $event.stopPropagation()"
                                        [(ngModel)]="linha[coluna.columnName]"
                                        [ngModelOptions]="{ standalone: true }"
                                    >
                                    <option *ngFor="let data of linha [coluna.selectColumn.options]" [value]="data.label">
                                        {{ data.label }}
                                    </option>
                                    </select>
                                    <div class="input-group-append">
                                        <button
                                            (click)="stopEdit(indexDado, indexColuna); $event.stopPropagation()"
                                            class="btn btn-outline-secondary"
                                            type="button"
                                            id="button-target"
                                        >
                                            <i class="bi bi-check2"></i>
                                        </button>
                                    </div>
                                </div>
                            </ng-container>

                        </td>

                        <td *ngIf="downloadAttachment" class="text-center col-1 font-weight-bold">
                            <i class="bi bi-arrow-down text-success" style="cursor: pointer;" (click)="downloadAttachment(linha)"></i>
                        </td>
                        <td *ngIf="detailsRow" class="text-center">
                            <i class="bi bi-plus-lg text-success" style="cursor: pointer;" (click)="detailsRow(linha)"></i>
                        </td>

                        <td *ngIf="deleteRow" class="text-center col-1">
                            <i class="bi bi-x-lg text-danger" style="cursor: pointer;" (click)="deleteRow(linha)"></i>
                        </td>
                    </ng-template>
                    <ng-container [ngTemplateOutlet]="rowTemplate||defaultRow"
                                  [ngTemplateOutletContext]="{ linha: linha, colunas: colunas}">
                    </ng-container>
                </tr>
                </tbody>
            </table>
            <ngb-pagination *ngIf="pageSize && dados?.length"
                            [(page)]="page"
                            [pageSize]="_pageSize"
                            [collectionSize]="dados.length"
                            [maxSize]="10"
                            [rotate]="true"
                            [boundaryLinks]="true">
            </ngb-pagination>
        </div>
    `
})
export class TableComponent {

    private _selectedRow: any;

    public page = 1;

    public editing = {};

    @Input()
    public colunas: TableRowConfig[];

    @Input()
    public dados: any [];

    @Input()
    public checkbox = false;

    @Input()
    public dblRowClick: (row: any) => void | undefined;

    @Input()
    public selectable = false;

    @Input()
    public pageSize: null | number | undefined;

    @Input()
    public rowTemplate?: TemplateRef<any>;

    @Input()
    public centerHeaderAndRows = false;

    @Input()
    public tableStriped = false;

    @Output()
    public selectedRow = new EventEmitter<any>();

    @Input()
    public detailsRow: (row: any) => void | undefined;

    @Input()
    public deleteRow: (row: any) => void | undefined;

    @Input()
    public downloadAttachment: (row: any) => void | undefined;

    @ViewChildren('inputField') inputFields: QueryList<ElementRef>;
    getClassMap(linha: any) {
        const classMap = {
            'text-center': this.centerHeaderAndRows
        };
        if (linha?.condition) {
            classMap[linha?.class] = true;
        }
        return classMap;
    }

    get _pageSize() {
        return this.pageSize ? this.pageSize : this.dados?.length + 1;
    }

    isEditing(indexDados, indexColunas) {
        return !!this.editing[indexDados + "-" + indexColunas];
    }

    startEdit(indexDados, indexColunas) {
        if (this.colunas[indexColunas].editable) {
            this.editing[indexDados + "-" + indexColunas] = true;
        }
    }

    stopEdit(indexDados, indexColunas) {
        this.editing[indexDados + "-" + indexColunas] = false;
        if (this.colunas[indexColunas].onAfterEdit) {
            this.colunas[indexColunas].onAfterEdit(this.dados[indexDados]);
        }
    }

    rowClick(row) {

        if (this.selectable && !this._selectedRow) {
            row._selected = true;
            this._selectedRow = row;
            this.selectedRow.emit(row);
        } else if (this.selectable && this._selectedRow) {
            this._selectedRow._selected = false;
            this._selectedRow = undefined;
            this.rowClick(row);
        } else {
            row._selected = false;
            this._selectedRow = undefined;
        }

    }

    focusNextInput(event: KeyboardEvent, indexDado: number, indexColuna: number) {
        event.preventDefault();

        const nextColunaIndex = indexColuna + 1;

        this.stopEdit(indexDado, indexColuna);

        if (nextColunaIndex < this.colunas.length && this.colunas[nextColunaIndex].editable) {
            this.startEdit(indexDado, nextColunaIndex);
            setTimeout(() => {
                const inputs = this.inputFields.toArray();
                const currentIndex = inputs.findIndex(input => input.nativeElement === event.target);

                if (currentIndex !== -1 && currentIndex < inputs.length - 1) {
                    const nextInput = inputs[currentIndex + 1].nativeElement;
                    nextInput.focus();
                }
            });
        }
    }

}

export interface TableRowConfig {
    columnName?: string;
    title: string;
    editable?: boolean;
    onAfterEdit?: (row: any) => void;
    options?: {
        currency?: boolean,
        date?: boolean,
        datetime?: boolean,
        [key: string]: boolean,
    };
    button?: {
        actionButton?: (row: any) => void;
    };
    styles?: {[p: string]: string};
    stylesTitle?: {[p: string]: string};
    selectColumn?: {
        options: string;
    };
}
